export const isForex = () => {
  const location = window.location;
  return location.pathname.includes("forex");
};
